import { W as WuiDivider$1, d as defineCustomElement$1 } from './divider.js';

const WuiDivider = WuiDivider$1;
const defineCustomElement = defineCustomElement$1;

export { WuiDivider, defineCustomElement };

//# sourceMappingURL=wui-divider.js.map